import React from "react";
import { Button } from "../components/ui/button";
import { ExternalLink, BarChart3, Info, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const DASHBOARD_IMG = "https://customer-assets-wrfwihn1.emergentagent.net/job_oversight-portal-3/artifacts/f7gm5yav_Capture%202026-07-26_02-39-54_PM2.webp";
const GRAFANA_URL = "https://insight.netsapiens.com/grafana/login";

export default function NSInsight() {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[12px] text-muted-foreground inline-flex items-center gap-1.5">
            <span className="cursor-pointer hover:text-foreground" onClick={() => navigate("/")}>Dashboard</span>
            <span>›</span>
            <span className="cursor-pointer hover:text-foreground" onClick={() => navigate("/apps")}>Apps</span>
            <span>›</span>
            <span className="inline-flex items-center gap-1 text-foreground font-medium">
              <BarChart3 className="w-3.5 h-3.5 text-primary" /> NS Insight
            </span>
          </div>
          <h1 className="text-[26px] font-semibold tracking-tight mt-2">Cluster health — UnitedCloud NMS</h1>
          <p className="text-[13px] text-muted-foreground">Live NetSapiens Insight Grafana dashboard (placeholder view).</p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => navigate(-1)} className="gap-1.5"><ArrowLeft className="w-4 h-4" /> Back</Button>
          <Button asChild size="sm" className="gap-1.5">
            <a href={GRAFANA_URL} target="_blank" rel="noopener noreferrer"><ExternalLink className="w-4 h-4" /> Open Real Insight</a>
          </Button>
        </div>
      </div>

      <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 text-amber-900 dark:text-amber-200 p-3 text-[12.5px] inline-flex items-start gap-2 max-w-3xl">
        <Info className="w-4 h-4 mt-0.5 shrink-0" />
        <div>
          <strong>Placeholder view — waiting on reverse-proxy.</strong> NetSapiens has declined to whitelist this domain, so live embedding is blocked at their end. We're planning to route NS Insight through a reverse-proxy service (Frameable / dock.co / iframely / self-hosted) — until that's live this static snapshot stands in.
        </div>
      </div>

      <div className="rounded-xl border border-border bg-slate-950 overflow-hidden shadow-inner">
        <img src={DASHBOARD_IMG} alt="NetSapiens Insight — Cluster Home dashboard" className="w-full h-auto block" />
      </div>
    </div>
  );
}
